import { MoonStar, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { MATTRESS_STUDIO } from "../data/site";

export const MattressStudio = () => (
  <section id="alvasstudio" data-testid="mattress-section" className="scroll-mt-24 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl card-shadow-lg">
            <img
              src={MATTRESS_STUDIO.image}
              alt={MATTRESS_STUDIO.imageAlt}
              loading="lazy"
              className="h-[260px] w-full object-cover sm:h-[380px]"
              data-testid="mattress-image"
            />
            <span className="absolute left-5 top-5 rounded-full bg-gold px-3.5 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.16em] text-night">
              {MATTRESS_STUDIO.imageBadge}
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="eyebrow mb-3 flex items-center gap-2">
            <MoonStar className="h-4 w-4" />
            {MATTRESS_STUDIO.eyebrow}
          </p>
          <h2 className="font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl">
            {MATTRESS_STUDIO.title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-soft sm:text-lg" data-testid="mattress-intro">
            {MATTRESS_STUDIO.text}
          </p>

          <div className="mt-6 flex flex-wrap gap-2.5" data-testid="mattress-type-pills">
            {MATTRESS_STUDIO.types.map((t) => (
              <span
                key={t}
                className="rounded-full border border-gold/50 bg-gold/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-[#8a6a12]"
              >
                {t}
              </span>
            ))}
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-x-8 gap-y-4" data-testid="mattress-brands">
            {MATTRESS_STUDIO.brands.map((b) =>
              b.logo ? (
                <img key={b.name} src={b.logo} alt={`${b.name} logó`} loading="lazy" className="h-8 w-auto object-contain" />
              ) : (
                <span key={b.name} className="font-display text-xl font-semibold italic text-ink">
                  {b.name}
                </span>
              )
            )}
          </div>

          <a
            href={MATTRESS_STUDIO.linkHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mattress-link"
            className="mt-8 inline-flex items-center gap-1.5 text-sm font-bold text-burgundy underline-offset-4 hover:underline"
          >
            {MATTRESS_STUDIO.linkLabel}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
